import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { LoggingInterceptor } from './commons/services/LoggingInterceptor';
import { AuthModule } from './modules/auth/auth.module';
import { provideClientHydration } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { graphqlProvider } from './graphQL/graphql.provider';
import { provideTranslation } from './commons/providers/translation.provider';
import { provideStore } from '@ngrx/store';
import { actionShellReducer } from './commons/storage/state/state.reducer';
import { StoreConfigurationService } from './graphQL/services/store-configurations/store-configurations.service';


export function initializeApp(storeConfigService: StoreConfigurationService): () => Promise<void> {
  return () => {
    return new Promise<void>((resolve, reject) => {
      storeConfigService.getStoreConfigurations().subscribe({
        next: (resp:any) => {
          // Configuraciones de la tienda cargadas

          if (resp.ConfigurationStore?.[0]?.LanguageTemplateStore) {
            const languageTemplateUrl = resp.ConfigurationStore[0].LanguageTemplateStore;
            const languageTemplateIdentifier = resp.ConfigurationStore[0].languageIdentifier;
            
            // Guardar la URL de la plantilla de idioma en localStorage
            localStorage.setItem('languageTemplateUrl', languageTemplateUrl);
            localStorage.setItem('languageTemplateIdentifier', languageTemplateIdentifier);
          }
          resolve();
        },
        error: (error) => {
          reject(error);
        }
      })
    })
  }
}

export const appConfig: ApplicationConfig = {
  providers:
    [provideRouter(routes)
      , provideClientHydration()
      // , AuthModule
      , MessageService
      , graphqlProvider
      , provideAnimations()
      , provideHttpClient(withInterceptorsFromDi())
      , { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true }
      , provideStore({ shell: actionShellReducer })
      , {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [StoreConfigurationService],
        multi: true
        }
      , provideTranslation()]
};

